<template>
  <v-sheet class="pa-2" border elevation="0">
    <div class="text-h6">Informations de paiement</div>
    <div class="d-flex gap align-center">
      <div>
        Total : <b>{{ commande.prix_total }}€</b> (dont taxe. {{ commande.taxe }}€)
      </div>
      <v-chip v-if="commande.cycle == 'CLOSED'" color="green-darken-4">{{ commande.cycle }}</v-chip>
      <v-chip v-else color="deep-orange-darken-4">{{ commande.cycle }}</v-chip>
      <v-chip v-if="commande.statut == 'PAID'" color="green-darken-4">{{ commande.statut }}</v-chip>
      <v-chip v-else color="deep-orange-darken-4">{{ commande.statut }}</v-chip>
    </div>
  </v-sheet>
</template>

<script>
export default {
  props: ["commande"],
};
</script>

<style lang="scss" scoped>
</style>